module.exports = __webpack_public_path__ + "static/media/register-user.5aabb222.svg";